var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "12px",
    viewBox: "0 0 7 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.8821143,12 L15.1572571,10.0002857 L13.0452571,10.0002857 L13.0452571,9.03085714 C13.0452571,8.41371429 13.2166857,7.99285714 14.1029714,7.99285714 L15.2309714,7.992 L15.2309714,6.084 C15.0364,6.05828571 14.3661143,6 13.5852571,6 C11.9566857,6 10.8424,6.99428571 10.8424,8.82 L10.8424,10.0002857 L9.0004,10.0002857 L9.0004,12 L10.8424,12 L10.8424,18 L13.0452571,18 L13.0452571,12 L14.8821143,12",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Share-/-Facebook",
    transform: "translate(-9.000000, -6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Fill-2",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallFb);
export default __webpack_public_path__ + "static/media/small-fb.652f606f92c4877dd3955fa76869e854.svg";
export { ForwardRef as ReactComponent };